// extracted by mini-css-extract-plugin
export default {"publicQuestionsContainer":"_3pbVV2WL"};